const nl = {
  "login": "Inloggen",
  "logout": "Uitloggen",
  "password": "Wachtwoord",
  "confirm_password": "Wachtwoord bevestigen",
  "forgot_password": "Wachtwoord vergeten?",
  "reset_password": "Wachtwoord opnieuw instellen",
  "reset_password_message": "Welkom {ph_name}! Hier kun je je wachtwoord opnieuw instellen.",
  "register": "Registreren",
  "register_message": "Welkom bij 42Workspace {ph_name}! We zijn blij je hier te hebben.",
  "my_account": "Mijn account",
  "username": "Gebruikersnaam",
  
  "account": "Account",
  "name": "Naam",
  "email": "E-mail",
  "image": "Afbeelding",
  "personal_code": "Persoonlijke code",
  "date_added": "Datum aangemaakt",
  "role": "Rol",
  "roles": "Rollen",
  "rights": "Rechten",
  "identifier": "Systeem-ID",
  "delete_account": "Account verwijderen",
  "user": "Gebruiker",
  "users": "Gebruikers",
  "company_manager": "Bedrijfsbeheerder",
  "default_role": "Standaard bedrijfs rol",
  "system_account": "Systeemaccount",
  "system_accounts": "systeemaccounts",
  "email_bookings": "Bevestigings e-mails voor boekingen",
  "email_invitations": "Ontvang e-mails voor uitnodigingen",

  "company": "Bedrijf",
  "companies": "Bedrijven",
  "my_company": "Mijn bedrijf",
  "manage_company": "Beheer bedrijf",
  "delete_users_in_company": "Gebruikers in bedrijf verwijderen",
  "keep_users_in_company": "Gebruikers in bedrijf behouden",
  "max_users": "Maximaal aantal gebruikers",

  "welcome": "Welkom",
  "home": "Home",
  "settings": "Instellingen",
  "information": "Informatie",
  "info": "Informatie",
  "pages": "Pagina's",
  "page": "Pagina",
  "order": "Volgorde",
  "move_up": "Omhoog verplaatsen",
  "move_down": "Omlaag verplaatsen",
  "show_more": "Laat meer zien",
  "showing": "Toont {ph_length} van {ph_count}",
  "select": "Selecteren",
  "no_results": "Geen resultaten",
  "availability": "Availability",
  "date": "Date",
  "time": "Time",
  "new": "New",
  "content": "Inhoud",
  "confirm": "Bevestigen",
  "close": "Sluiten",
  "add": "Toevoegen",
  "remove": "Verwijderen",
  "edit": "Bewerken",
  "clear": "Wissen",
  "actions": "Actions",
  "delete": "Verwijderen",
  "amount_of": "Aantal",
  "language": "Taal",
  "theme": "Thema",
  "language_codes": {
    "EN": "Engels",
    "NL": "Nederlands"
  },
  "themes": {
    "light_mode": "Lichte modus",
    "dark_mode": "Donkere modus",
    "barbie_mode": "Barbie modus",
    "smurf_mode": "Smurf modus",
    "shrek_mode": "Shrek modus",
  },

  "all_bookings": "Bekijk alle boekingen",
  "cannot_extend": "Je kunt deze boeking niet verlengen.",
  "booking": "Boeking",
  "book": "Book",
  "bookings": "Boekingen",
  "make_booking": "Maak een boeking",
  "book_a_room": "Boek een kamer",
  "your_booking": "jouw boeking",
  "my_bookings": "Mijn boekingen",
  "upcoming_bookings": "Aankomende boekingen",
  "no_bookings": "Je hebt momenteel geen boekingen...",
  "no_upcoming_bookings": "Je hebt momenteel geen aankomende boekingen...",
  "want_to_create": "Wil je een kamer boeken?",
  "room_availability": "Beschikbaarheid van kamers",
  "title": "Titel",
  "description": "Beschrijving",
  "attendees": "Deelnemers",
  "extend_booking": "Boeking verlengen",
  "manage_booking": "Boeking beheren",
  "open_times": "Openingstijden",
  "hours": "uren",
  "timeline": "Tijdlijn",
  "upcoming": "Aankomende",
  "creator": "Creator",

  "room": "Kamer",
  "rooms": "Kamers",
  "room_type": "Kamertype",
  "capacity": "Capaciteit",
  "floor": "Verdieping",
  "opening_hours": "Openingstijden",
  "opening_time": "Openingstijd",
  "closing_time": "Sluitingstijd",
  "active": "Actief",
  "inactive": "Inactief",

  "preferences": "Voorkeuren",
  "third_party_integrations": "Derden integraties",
  "notifications": "Meldingen",
  "sync_calendar": "Synchroniseer agenda",
  "current_users": "Huidige gebruikers",
  "credits": "Credits",
  "pending_registrations": "Registraties in afwachting",
  "resend": "Opnieuw verzenden",

  "filters": "Filters",
  "display": {
    "currentlyOccupied": "Momenteel bezet",
    "free": "Vrij",
    "bookRoom": "Boek een kamer",
    "minutes": "minuten",
    "welcome": "Welkom",
    "bookingFrom": "Je boeking is van",
    "to": "tot",
    "enterPassword": "Voer systeemwachtwoord in:",
    "loggingOut": "Bezig met uitloggen...",
    "logout": "Uitloggen",
    "logoutSuccess": "Met succes uitgelogd",
    "logoutError": "Onjuist wachtwoord of uitloggen mislukt",
    "quickBook": "Snel boeken",
    "till": "tot",
    "book": "Boek",
    "from": "van",
    "signInPC": "Aanmelden met persoonlijke code",
    "signInQR": "Aanmelden met QR-code",
    "confirmBooking": "Bevestig snelle boeking",
    "qrUnavailable": "Geen QR-code beschikbaar",
    "closingIn": "Sluit over",
    "second": "seconde",
    "secondPlural": "seconden",
    "minute": "minuut"
  },

  "admin": "Admin Paneel",
  "admin_tabs": {
    "companies": "Bedrijven",
    "users": "Gebruikers",
    "roles": "Rollen",
    "rooms": "Kamers",
    "bookings": "Boekingen",
    "statistics": "Statistieken",
    "info": "Informatiepagina's",
    "systemAccounts": "Systeemaccounts"
  },

  "toast": {
    "fill_all_fields": "Vul alstublieft alle verplichte velden in.",
    "register_message": "Registratielink succesvol verzonden naar {ph_email}.",
    "reset_password_message": "Wachtwoordresetlink succesvol verzonden naar {ph_email}.",
    "user_edit": "Gebruiker {ph_name} succesvol bijgewerkt.",
    "password_mismatch": "Wachtwoorden komen niet overeen.",
    "register_complete": "Je registratie is voltooid. Je kunt nu inloggen.",
    "password_reset_complete": "Je registratie is voltooid. Je kunt nu inloggen.",
    "server_error": "Sorry, er is een fout bij ons. Probeer het later opnieuw.",
    "role_not_empty_error": "Deze rol bevat gebruikers en kan niet worden verwijderd. Verwijder eerst alle gebruikers van deze rol.",
    "created_success": "succesvol aangemaakt.",
    "updated_success": "succesvol bijgewerkt.",
    "deleted_success": "succesvol verwijderd.",
    "confirm_delete_general": "Weet je zeker dat je {ph_name} wilt verwijderen?",
    "confirm_delete_company": "Weet je zeker dat je {ph_name} wilt verwijderen? Er zijn {ph_users} gebruikers in dit bedrijf.",
    "register_send_message": "Er is een registratielink verzonden naar {ph_name}.",
    "booking_success": "Je boeking is gelukt.",
    "name_too_long": "Wow, dat is een lange naam!"
  }
}

export default nl;
